export default "__VITE_ASSET__BL4cYI4b__"